// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","routesWrapper":"App_routesWrapper__GIdDy"};